export class EmergesRequest{ 
    healthUnitName: string;
    cnpj: string;
    email: string;
    idHealthUnit: number;
}